export const REGISTER_USER = "register_user_requested";
export const UPDATE_USER = "update_user_requested";
export const PINCODE_ADDRESS = "pincode_address_requested";
export const REGISTER_DATA_UPDATE = "register_form_update";
export const REGISTER_USER_SUCCESS = "register_user_success";
export const REGISTER_USER_FAIL = "register_user_fail";
export const DELETE_ACCOUNT_FAIL = "delete_account_fail";
export const REGISTER_RESET = "register_form_reset";
export const LOGIN_USER = "login_user_requested";
export const LOGIN_DATA_UPDATE = "login_data_update";
export const LOGIN_USER_SUCCESS = "login_user_success";
export const LOGIN_USER_FAIL = "login_user_fail";
export const USER_PROFILE = "login_user_data";
export const OTP_VERIFY = "otp_verification";
export const USER_ORDERS_DATA = "USER_ORDERS";
export const GET_USER_DATA = "user_data";
export const DELETE_ACCOUNT = "delete_account";
export const FETCHRATES = "gold/silver rates";
export const RATE_SUCCESS = "rate fetched";
export const RATE_FAIL = "rate failed";
export const GOLD_SILVER_RATES = "gold silver rates";
export const REFRESH_TOKEN = "refresh token";
export const PUSH_NOTIFICATION = "push notification";
export const ACRU_LOGIN = "Acru login";
export const TXN_FAIL = "transaction fail";
export const TXN_SUCCESS = " transaction sucess";
export const TXN_DATA = "transaction data";
export const ORDER_STATUS = "order sucess";
export const START_TXN = "start transaction";
export const UPDATE_WISH_ORDER = "update wish order";
export const ORDER_SUCCESS = " order sucess";
export const ORDER_FAIL = " order failed";
export const PURCHASE_DETAILS = "purchased details";
export const PURCHASE_DETAILS_SUCCESS = "purchased details success";
export const PURCHASE_DETAILS_FAIL = "purchased details fail";
export const GIFT_SENT = "Gift sent";
export const GIFT_SENT_DETAILS = "purchased details";
export const GIFT_SENT_SUCCESS = "purchased details success";
export const GIFT_SENT_FAIL = "purchased details fail";
export const GIFT_INVESTMENT_SUCCESS = "investment sucess";
export const GIFT_INVESTMENT_FAIL = "investment fail";
export const NOTIFICATIONS_SUCCESS = "notifications sucess";
export const NOTIFICATIONS_FAIL = "notifications fail";
export const RELATION_SUCCESS = "relation success";
export const RELATION_FAIL = "relation fail";
export const FETCHRELATION = "relation API";
export const GETRELATION = "get relation API";
export const GET_COUNTRY_CODE = "get country code";
export const CREATE_CIRCLE = "create new circle";
export const GET_CIRCLE = "get  circle";
export const GET_USER_CIRCLE = "get user()family circle";
export const ADD_USER_DETAIL = "add user detail";
export const DELETE_CIRCLE = "delete  circle";
export const DELETE_USER_CIRCL = "delete circle user";
export const CREATE_EVNT = "create event";
export const CREATE_ADDRES = "create address";
export const GET_ADDRES = "get address";
export const DELETE_ADDRES = "delete address";
export const UPDATE_ADDRES = "update address";
export const SELF_ORDER_STATUS = "self order status";
export const START_SELF_TXN = "self order txn start";
export const TXN_SELF_SUCCESS = "txn self sucess";
export const TXN_SELF_FAIL = "txn self fail";
export const GET_INVESTMENT = "get investment data";
export const GET_MUTUAL_FUND_INVESTMENT = "get mutual fund investment data";
export const SKIP_KYC = "skip kyc";
export const GET_USER_SUPPORT = "get user support data";
export const GET_NOMINEE_LIST = "get nominee list";
export const CREATE_NOMINEE = "creare nominee";
export const GET_MUTUAL_FUND_HOLDING = "get mutual fund holding data";
export const GET_MUTUAL_FUND_SIP_HOLDING = "get mutual fund sip holding data";
export const GET_SUPPORT_TICKET_TAGS = "get support ticket tags";
export const CREATE_SUPPORT_TICKET_TAGS = "create user support ticket";
export const GET_MUTUAL_FUND_LIST = "get mutual fund list";
export const GET_FLASH_CARD_LIST = "get flash card list";
export const GET_MUTUAL_FUND__CATEGORY_LIST = "get mutual fund category list";
export const GET_MUTUAL_FUND__SIP_LIST = "get customer sip sip list";
export const GET_MUTUAL_FUND_TRANSACTIONS = "get mutual fund transaction list";
export const GET_ELSS_MUTUAL_FUND__SIP_LIST = "get elss sip sip list";
export const GET_FUND_SIP_LIST = "get fund sip sip list";
export const GET_SERACHED_FUND_LIST = "get searched fund list";
export const GET_MUTUAL_FUND__CUSTOMER_WORKFLOW_USER_GET = "get customer workflow user info get";
export const GET_MUTUAL_FUND__FUND_CARD = "get mutual funds card";
export const GET_MUTUAL_FUNDs_REDEEM = "mutual funds redeem";
export const GET_FOLIO_HISTORY = "get folio history";
export const UPDATE_ESIGN = "update esign mutual funds card";
export const GET_MUTUAL_FUND__FUND_HOLDING = "get mutual funds card holding";
export const GET_MUTUAL_FUND__SIP_DETAIL = "get mutual funds sip detail card holding";
export const GET_MUTUAL_FUND__SIP_FOLIO_DETAIL = "get mutual funds folio detail card holding";
export const KYC_VERIFY_DETAILS = "update kyc mutual fund details";
export const UPLOAD_PHOTO_MUTUAL_FUND_DETAIL = "upload photo mutual fund details";
export const KYC_CREATE_MUTUAL_FUND = "kyc create mutual fund details";
export const INVESTOR_CREATE_MUTUAL_FUND = "investor create mutual fund details";
export const GET_OTP_MUTUAL_FUND = "get otp mutual fund";
export const INVESTMENT_CREATE_MUTUAL_FUND = "investment create mutual fund details";
export const UPDATE_PAN_MUTUAL_FUND = "update PAN for mutual funds";
export const UPDATE_IFSC_MUTUAL_FUND = "update IFSC for mutual funds";
export const VERIFY_BANK_DETAIL_MUTUAL_FUND = "verify bank detail for mutual funds";
export const ORDER_MUTUAL_FUND = "order mutual fund";
export const LUMPSUM_ORDER_MUTUAL_FUND = "lumpsum order mutual fund";
export const GET_MUTUAL_FUND_KYC = "get mutual fund kyc";
export const ACTIVATE_KYC = "activate fund kyc";
export const ALL_TXN_FAIL = "all txn fail";
export const ALL_TXN_SUCCESS = "all txn success";
export const ALL_TRANSACTION = "all txn";
export const AADHAAR_SESSION = "start aadhar session";
export const AADHAAR_SESSION_SUCCESS = "aadhaar session success";
export const AADHAAR_SESSION_FAIL = "aadhaar session fail";
export const AADHAAR_GERNATE_OTP = "aadhaar gernate otp";
export const AADHAAR_GERNATE_OTP_SUCCESS = "aadhaar gernate otp sucess";
export const AADHAAR_GERNATE_OTP_FAIL = "aadhaar gernate otp fail";
export const AADHAAR_VERIFY_OTP = "aadhaar verify otp";
export const GET_KYC = "get kyc details";
export const PAN_CARD_UPDATE = "pan card update";
export const GET_BALANCE = "get balance";
export const GET_BANK = "get bank";
export const CREATE_ORDER = "create sell order";
export const REDEEM_PRODUCTS = "redeem product list";
export const CHECK_PINCODE = "check pincode";
export const REDEEM_ORDER = "redeem order";
export const REDEEM_ORDER_STATUS = "redeem order status";
export const GET_ONGOING_EVNT = "ongoing event ";
export const ADD_USER_INTO_EVNT = "Add User Into Event";
export const ALL_SELF_INVETMNT = "All Self Investment";
export const GET_EVENT_WISHES = 'get event wishes';
export const GET_EVENT_MEDIA = 'get event media'
export const SEND_EVENT_WISH = 'send wishes'
export const MAIN_BALNCE_API = "Main Balance";
export const NOTIFICATIONS_LIST_API = "Notification List";
export const UPDATE_NOTIFICATIONS_LIST_API = "Update Notification List";
export const CREATED_EVENT ='created event';
export const INVITED_EVENT = 'invited event';
export const CREATE_BANK = "Add Bank Account";
export const GET_ACCOUNT = "get bank account";
export const DELETE_RELTION="delete relation";
export const DELETE_EVNT="delete event";
export const UPDATE_EVNT = "update event";
export const VALIDATE_VERSION_OF_APP = 'app version'
export const VERSION_SUCCESS = 'version api success'
export const VERSION_FAIL = 'version api fail'
export const TXN_HISTORY = "transaction history";
export const PORTFOLIO_DATA = 'portfolio data';
export const GET_MUTUAL_FUNDs_OTPVERIFY = 'MutualFund otp verify'
export const GET_MUTUAL_FUNDs_OTPGENERATE = 'MutualFund otp generate';
export const CREATE_MF_MANDATE = 'create mf mandate';
export const GET_MF_MANDATE = 'get mf mandate';
export const CREATE_MF_SIP = 'create mf sip';
export const GET_USER_DETAIL = 'Get user detail';
export const GET_MUTUAL_FUND_GRAPHDATA = "MF graph data"
export const GET_POPULAR_FUND_LIST = 'popular fund list';
export const GET_GOLD_COINS_DATA = "get gold coins data";
export const  BUY_GOLD_COINS_CALL = "Buy gold coins";
export const RESND_OTP ="resend otp";
export const CREATE_POT= "Create POT"
export const GET_POT_LIST = "get pot list";
export const PROFILE_PHOTO="profile photo upload";
export const GIFT_STATUS="Gift status";
export const CREATE_GOLD_POT="create gold pot";
export const GOLDSILVER_POT_CHECK="Gold/Silver pot check";
export const CANCEL_METAL_GOALS="cancel metal goal";
export const CANCEL_MF_GOALS = "cancel mf goal";
export const SELL_METAL_GOALS="sell metal";
export const GET_MUTUAL_FUND_SIP="display all SIP";
export const CANCEL_MF_SIP="cancel SIP";
export const GET_NFO_LIST="NFO list";
export const SKIP_MF_SIP="skip SIP";